var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelivery = function SvgDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_2433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.313 38.2629H64.1644V47.7143H81.4021L76.6742 40.5981C75.7024 39.1359 74.0722 38.2629 72.313 38.2629Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2956 51.1908H62.4206C61.4576 51.1908 60.677 50.4124 60.677 49.4526V35.2147C60.677 32.3393 58.3304 30 55.4462 30H12V69.2363H16.1019C16.9554 64.336 21.2488 60.597 26.4047 60.597C31.5604 60.597 35.8539 64.336 36.7074 69.2363H62.0599C62.9134 64.336 67.2068 60.597 72.3625 60.597C77.5182 60.597 81.8117 64.336 82.6652 69.2363H88.9701V57.9006C88.9701 56.4925 88.387 55.1243 87.3703 54.1469L84.2956 51.1908Z",
    fill: "#E9DBBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5229 77.8863C31.3241 77.2713 33.9056 73.7008 33.2887 69.9113C32.6718 66.1219 29.0901 63.5485 25.2889 64.1635C21.4876 64.7785 18.9062 68.3491 19.5231 72.1385C20.14 75.928 23.7216 78.5014 27.5229 77.8863Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3624 77.9757C76.2133 77.9757 79.335 74.8635 79.335 71.0246C79.335 67.1856 76.2133 64.0735 72.3624 64.0735C68.5116 64.0735 65.3899 67.1856 65.3899 71.0246C65.3899 74.8635 68.5116 77.9757 72.3624 77.9757Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_2433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery.6a8e62a5.svg";
export { ForwardRef as ReactComponent };